import React, { useMemo } from "react";
import { useCategoriesUIContext } from "../CategoriesUIContext";

export function CategoriesGrouping() {
  // Categories UI Context
  const categoriesUIContext = useCategoriesUIContext();
  const categoriesUIProps = useMemo(() => {
    return {
      ids: categoriesUIContext.ids,
      setIds: categoriesUIContext.setIds,
      openDeleteCategoriesDialog: categoriesUIContext.openDeleteCategoriesDialog,
      openFetchCategoriesDialog: categoriesUIContext.openFetchCategoriesDialog,
      openUpdateCategoriesStatusDialog:
        categoriesUIContext.openUpdateCategoriesStatusDialog,
    };
  }, [categoriesUIContext]);

  return (
    <div className="mb-4">
      <div
        className="card card-custom py-3 px-6 d-flex flex-row align-items-center justify-content-between flex-wrap shadow-xs"
        style={{
          backgroundColor: "#f8f9fc",
          borderRadius: "8px",
          border: "1px solid #e2e8f0",
        }}
      >
        <div className="d-flex align-items-center my-1">
          <span className="font-weight-bolder font-size-sm text-dark mr-3">
            Selected Categories:
          </span>
          <span
            className="badge badge-primary font-weight-bolder font-size-sm py-2 px-3"
            style={{ minWidth: "32px", borderRadius: "6px" }}
          >
            {categoriesUIProps.ids.length}
          </span>
        </div>
        <div className="d-flex align-items-center my-1" style={{ gap: "8px" }}>
          <button
            type="button"
            className="btn btn-primary btn-sm font-weight-bolder px-4 py-2 d-inline-flex align-items-center shadow-xs"
            onClick={categoriesUIProps.openUpdateCategoriesStatusDialog}
          >
            <i className="fa fa-sync-alt mr-2 font-size-xs"></i>
            Update Status
          </button>
        </div>
      </div>
    </div>
  );
}
